// Raw-feeding calculators. Both modes are the same shape — a percentage of
// body weight, converted to ounces (x16) — and both percentages come from the
// client's own live calculator rather than a generic raw-feeding table:
//   rawdogfoodandco.com/wp-content/themes/rawdogfood/assets/js/scripts.js
//
//   adult  weight x 0.025  (0.4 oz per lb, which is what the comp's worked
//                           example shows: 55lb -> 22.0oz)
//   puppy  weight x the age bracket's rate, 0.10 down to 0.025
//
// The puppy rate rides on the <option value>, so the brackets live in one
// place (the Liquid) instead of being mirrored in a lookup table here.
//
// Adult takes IDEAL weight, puppy takes CURRENT weight — a growing puppy is
// fed to what it is now, not what it will become.
(function () {
  function formatOz(oz) {
    return oz.toFixed(1);
  }
  function formatLbs(oz) {
    return (oz / 16).toFixed(2);
  }

  function calculate(card) {
    const weightInput = card.querySelector('[data-rdf-calc-weight]');
    const weight = parseFloat(weightInput.value);
    if (!weight || weight <= 0) {
      weightInput.focus();
      return;
    }

    // Adult is a fixed 2.5%; puppy reads its rate off the selected bracket.
    let rate = 0.025;
    if (card.dataset.mode === 'puppy') {
      const ageSelect = card.querySelector('[data-rdf-calc-age]');
      const notice = card.querySelector('[data-rdf-calc-notice]');
      rate = parseFloat(ageSelect && ageSelect.value);
      if (!rate) {
        // No bracket picked — prompt for it rather than guessing a stage.
        if (notice) notice.hidden = false;
        if (ageSelect) ageSelect.focus();
        return;
      }
      if (notice) notice.hidden = true;
    }

    const dailyOz = weight * rate * 16;
    const weeklyOz = dailyOz * 7;
    const monthlyOz = dailyOz * 30;

    card.querySelector('[data-rdf-calc-dogweight]').textContent = Math.round(weight) + ' lb dog';
    card.querySelector('[data-rdf-calc-daily-oz]').textContent = formatOz(dailyOz) + ' oz';
    card.querySelector('[data-rdf-calc-daily-lbs]').textContent = formatLbs(dailyOz) + ' lbs';
    card.querySelector('[data-rdf-calc-weekly-lbs]').textContent = formatLbs(weeklyOz) + ' lbs';
    card.querySelector('[data-rdf-calc-weekly-oz]').textContent = formatOz(weeklyOz) + ' oz per week';
    card.querySelector('[data-rdf-calc-monthly-lbs]').textContent = formatLbs(monthlyOz) + ' lbs';
    card.querySelector('[data-rdf-calc-monthly-oz]').textContent = formatOz(monthlyOz) + ' oz per month';

    card.querySelector('[data-rdf-calc-results]').hidden = false;
  }

  function initCard(card) {
    const button = card.querySelector('[data-rdf-calc-submit]');
    if (!button) return;

    button.addEventListener('click', function () {
      calculate(card);
    });

    // Once a result is on screen, keep it honest as the inputs change rather
    // than leaving a stale number from the previous bracket.
    card.querySelectorAll('[data-rdf-calc-weight], [data-rdf-calc-age]').forEach(function (field) {
      field.addEventListener('change', function () {
        const results = card.querySelector('[data-rdf-calc-results]');
        if (results && !results.hidden) calculate(card);
      });
    });
  }

  document.querySelectorAll('[data-rdf-calculator]').forEach(initCard);
})();
